/**
 * DisableAddToCartButton - A class for disabling the add to cart button on the product single page
 */
class DisableAddToCartButton {
	/**
	 * Setup method
	 * Static method to set up the class on the page
	 *
	 * @return {void}
	 */
	static setup() {
		const elements = document.querySelectorAll('.single-product .qte-product-info-section');

		for (const element of elements) {
			const instance = new DisableAddToCartButton(element);
			instance.init();
		}
	}

	/**
	 * Constructor method
	 *
	 * @param {HTMLElement} element
	 * @return {void}
	 */
	constructor(element) {
		this.element = element;
	}

	/**
	 * Initialize method
	 * Method to initialize a class instance
	 */
	init() {
		this.handleDisabledCartButton();
	}

	/**
	 * handleDisabledCartButton
	 *
	 * @return {void}
	 */
	handleDisabledCartButton() {
		// Target Add to Cart button and disable by default
		let addToCartButton = jQuery("button[name='add-to-cart']");
		addToCartButton.prop('disabled', true);

		// Target file upload and shipping select elements
		let fileInput = jQuery('.fme_upload_file');

		// Function to check both file upload and shipping selection
		function checkRequirements() {
			// Check if the elements exist on the page
			const fileExists = fileInput.length > 0;

			if (fileExists) {
				const fileUploaded = fileInput.val() !== ''; // Check if a file has been uploaded

				// Enable button only if both conditions are met
				addToCartButton.prop('disabled', ! fileUploaded );
			}
		}

		// Listen for changes on file input (including removal) and shipping dropdown
		fileInput.on('change input', checkRequirements);

		// Reset Add to Cart button if file input is cleared
		fileInput.on('click', function () {
			jQuery(this).val(''); // Clear file input if clicked
			checkRequirements();
		});
	}
}

// The document is checked if it is ready. If it is, the setup() method is called.
if (document.readyState === 'interactive' || document.readyState === 'complete') {
	DisableAddToCartButton.setup();
} else {
	document.addEventListener('DOMContentLoaded', DisableAddToCartButton.setup);
}
